import { useAuthContext } from '../contexts/AuthContext'

const useApiAuthCheck = () => {
    const { logoutCtx, token } = useAuthContext()

    const callApiWithAuth = async(apiFunc) =>{
        if(!token){
            logoutCtx()
            return false
        }
        const ret = await apiFunc()
        if(ret.code === 401 || ret?.code === 403){
            logoutCtx();
        }
        return ret
    }
    return { callApiWithAuth }
}
export { useApiAuthCheck }